export enum ResponseStatus {
    OK = 'ok',
    ERROR = 'error',
}
